export const PERSONA_AGE_RANGES = ["Under 18", "18-24", "25-34", "35-44", "45-54", "55-64", "65+"] as const;
export const NO_PERSONA_AGE_RANGE_VALUE = "__none__";

export type PersonaAgeRange = (typeof PERSONA_AGE_RANGES)[number];

const PERSONA_AGE_RANGE_SET = new Set<string>(PERSONA_AGE_RANGES);

export const normalizePersonaAgeRange = (value: string | null | undefined): PersonaAgeRange | null => {
      if (typeof value !== "string") return null;

      const trimmed = value.trim();
      if (trimmed.length === 0) return null;

      const normalized = trimmed.replace(/[–—−]/g, "-").replace(/\s+/g, " ").trim();
      if (PERSONA_AGE_RANGE_SET.has(normalized)) {
            return normalized as PersonaAgeRange;
      }

      const lowered = normalized.toLowerCase();
      if (lowered === "under 18" || lowered === "under-18" || lowered === "<18") {
            return "Under 18";
      }

      if (
            lowered === "65+" ||
            lowered === "65 +" ||
            lowered === "65 plus" ||
            lowered === "65 and over" ||
            lowered === "65 or older" ||
            lowered === "65 or above"
      ) {
            return "65+";
      }

      const numericRangeMatch = normalized.match(/^(\d{1,2})\s*-\s*(\d{1,2})$/);
      if (!numericRangeMatch) return null;

      const candidate = `${numericRangeMatch[1]}-${numericRangeMatch[2]}`;
      return PERSONA_AGE_RANGE_SET.has(candidate) ? (candidate as PersonaAgeRange) : null;
};

export const toPersonaAgeRangeFormValue = (value: string | null | undefined): string =>
      normalizePersonaAgeRange(value) ?? "";

export const toNullablePersonaAgeRange = (value: string | null | undefined): PersonaAgeRange | null =>
      normalizePersonaAgeRange(value);
